export default {"src":"/_next/static/media/footer-arrow.c7505d6a.svg","height":80,"width":81,"blurWidth":0,"blurHeight":0};